query AnalyticsSalesByDeviceOs($filter: AnalyticsSalesFilterInput!) {
  analyticsSales(filter: $filter) {
    currency
    salesByDeviceOs {
      label
      sales
      revenue
    }
  }
}
